import React from "react";
const warnIcon = require("../../EventGalleryMobile/styles/icon-red-warn.svg");

const DeletePhotosConfirmation = ({
  closePopup,
  deletePhotos,
  isDeleting = false
}: {
  closePopup: Function;
  deletePhotos: Function;
  isDeleting?: boolean;
}) => {
  return (
    <div>
      <div
        id="filter-dialog"
        className="modal fade in geo-modal geo-modal--small geo-modal__remove-offer"
        role="dialog"
      >
        <div className="modal-dialog filter-dialog-content">
          <div className="modal-header">
            &nbsp;
            <button
              type="button"
              className="close"
              onClick={() => {
                closePopup();
              }}
            >
              <span>&times;</span>
            </button>
          </div>
          <div className="geo-modal__header geo-modal--warning-bg">
            <img
              className="geo-modal__warn-icon"
              src={warnIcon}
              alt="exclamation-warn"
            />
            <h4>Photos will be deleted </h4>
          </div>
          <div className="geo-modal__body">
            <p>Are you sure you want to delete all the selected photos?</p>
          </div>
          <div className="modal-footer geo-modal__actions dont-break">
            <a
              className="geo-btn geo-btn--link  geo-btn--caps"
              style={{ backgroundColor: "#C1C1C1", color: "white" }}
              onClick={() => {
                closePopup();
              }}
            >
              Cancel
            </a>
            <button
              type="button"
              className={`geo-btn geo-btn--secondary geo-btn--caps enhanced-search-delete-btn ${
                isDeleting ? "is-deleting" : ""
              }`}
              onClick={async () => {
                if (!isDeleting) {
                  deletePhotos();
                }
              }}
              disabled={isDeleting}
            >
              {isDeleting && (
                <i
                  className="fa fa-spinner fa-spin"
                  style={{ fontSize: "14px" }}
                />
              )}
              Delete
            </button>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade in" />
    </div>
  );
};

export default DeletePhotosConfirmation;
